/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
/** Custom Hooks */
import useDebounce from "../../app/customHooks/useDebounce";
/** Common Components */
import CardSection from "../../components/ui/card/CardSection";
/** Common Services & Data Files */
import SwalAlert from "../../services/swalService/SwalService";
import ToastService from "../../services/toastService/ToastService";
/** Configuration Files */
import { RoleGridConfig } from "./features/config/Role.data";
/** RTK Query */
import {
  useDeleteRoleMutation,
  useGetRolesMutation,
} from "../../app/services/RoleManagement";
/** CSS Files */
import "./RoleManagement.scss";
import CenterModel from "../../components/ui/centerModel/CenterModel";
import AddRoleManagement from "./features/AddEditRole";
import SidebarModel from "../../components/ui/sidebarModel/SidebarModel";
import FinalMolGrid from "../../components/FinalMolGrid/FinalMolGrid";
import AssignUser from "./features/AssignUser";
import { useNavigate } from "react-router-dom";
import { encryptUrlData } from "../../services/CryptoService";


const RoleManagement = (props) => {
  const molGridRef = useRef();
  const navigate = useNavigate();
  const { confirm } = SwalAlert();
  /* State*/
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedRoleId, setSelectedRoleId] = useState(null);
  const [roleId, setRoleId] = useState(null);
  const [dataSource, setDataSource] = useState([]);
  const [totalRowCount, setTotalRowCount] = useState(0);
  const [searchText, setSearchText] = useState("");
  const debouncedSearch = useDebounce(searchText, 300);
  // API'S Call
  const [getRoles, {
    isLoading: isListLoading,
    isSuccess: isListSuccess,
    data: RoleManagementData
  }] = useGetRolesMutation();
  
  const [deleteRole, {
    isSuccess: isDeleteSuccess,
    data: UserDataDelete
  }] = useDeleteRoleMutation();

  //** useEffect's */
  useEffect(() => {
    if (isListSuccess && RoleManagementData) {
      if (RoleManagementData) {
        setDataSource(RoleManagementData.dataSource);
      }
      if (RoleManagementData.totalRecord) {
        setTotalRowCount(RoleManagementData.totalRecord);
      }
    }
  }, [isListSuccess, RoleManagementData]);

  useEffect(() => {
    if (molGridRef.current) {
      const currentPageObject = molGridRef.current.getCurrentPageObject();
      const request = {
        pagination: {
          pageNumber: currentPageObject.pageNumber,
          pageSize: currentPageObject.pageSize,
        },
        filters: { searchText: debouncedSearch },
      };
      getRole(request);
    }
  }, [debouncedSearch]);

  useEffect(() => {
    if (isDeleteSuccess && UserDataDelete) {
      ToastService.success(UserDataDelete.errorMessage);
      const currentPageObject = molGridRef.current.getCurrentPageObject();
      const request = {
        pagination: {
          pageNumber: currentPageObject.pageNumber,
          pageSize: currentPageObject.pageSize,
        },
        filters: { searchText: props.search },
      };
      getRole(request);
    }
  }, [isDeleteSuccess && UserDataDelete]);

  //** Funcation's */
  const handleOnSearchChange = (e) => {
    let value = e.target.value;
    setSearchText(value);
  };

  const getRole = (pageObject) => {
    getRoles(pageObject);
  };

  const handlePageChange = (page) => {
    const request = {
      pagination: { pageNumber: page.pageNumber, pageSize: page.pageSize },
      filters: { searchText: debouncedSearch },
    };
    getRole(request);
  };

  const handleRoleModal = () => {
    setSelectedRoleId(null);
    setShowModal(!showModal);
    if (molGridRef.current) {
      const currentPageObject = molGridRef.current.getCurrentPageObject();
      const request = {
        pagination: {
          pageNumber: currentPageObject.pageNumber,
          pageSize: currentPageObject.pageSize,
        },
        filters: { searchText: props.search },
      };
      getRole(request);
    }
  };

  const onEditAction = (data) => {
    const encryptedRoleId = data.roleId;
    setSelectedRoleId(encryptedRoleId);
    setShowModal(true);
  };

  const onDeleteAction = (data) => {
    confirm(
      "Delete?",
      "Are you sure you want to Delete?",
      "Delete",
      "Cancel"
    ).then((confirmed) => {
      if (confirmed) {
        deleteRole(data.roleId);
      }
    });
  };
  const onAssignUser = (data) => {
    setRoleId(data.roleId);
    setIsModelOpen(true)
  }

  const handlePermission = (data) => {
    navigate(`/admin/roles/SecurityPermission/${encryptUrlData(data.roleId)}`);
  };
  const actionHandler = {
    EDIT: onEditAction,
    DELETE: onDeleteAction,
    USER: onAssignUser,
    PERMISSION: handlePermission,

  };

  const onSidebarClose = () => {
    setIsModelOpen(false);
  };

  return (
    <div>
      <div className="role-list center-top-space">
        <CardSection
          isContentLoading={isListLoading}
          cardTitle={"Role List"}
          rightButton={true}
          buttonClassName="theme-btn"
          titleButtonClick={handleRoleModal}
          buttonText="Role"
          textWithIcon={true}
          iconName="material-symbols:add-rounded"
          fontIcon={true}
          searchInputName="Search by Role Name"
          searchInput={true}
          handleChange={handleOnSearchChange}
        >
          <div className="table-grid">
            <FinalMolGrid
              ref={molGridRef}
              configuration={RoleGridConfig}
              dataSource={dataSource}
              allowPagination={true}
              pagination={{
                totalCount: totalRowCount,
                pageSize: 20,
                currentPage: 1,
              }}
              isLoading={isListLoading}
              onActionChange={actionHandler}
              onPageChange={handlePageChange}
            />

          </div>
        </CardSection>
      </div>
      <div>
        {showModal && (
          <CenterModel
            showModal={showModal}
            handleToggleModal={handleRoleModal}
            modalTitle={selectedRoleId ? "Update Role" : "Add Role"}
            modelSizeClass="w-40"
          >
            <div className="row">
              <AddRoleManagement
                onClose={handleRoleModal}
                roleId={selectedRoleId}
              />
            </div>
          </CenterModel>
        )}

        <SidebarModel
          isOpen={isModelOpen}
          onClose={onSidebarClose}
          modalTitle="Assign User"
          modalSize="w-40"
        >
          <AssignUser
            onSidebarClose={onSidebarClose}
            roleId={roleId}
            isOpen={isModelOpen} />
        </SidebarModel>
      </div>
    </div>
  );
};

RoleManagement.propTypes = {
  search: PropTypes.string,
};
export default RoleManagement;
